<template>
  <div id="app">
    <!-- <Tanggal /> -->
    <!-- <h1 class="monaco text-danger"><strong>codejam("FINAL")</strong></h1> -->
    <!-- <div id="nav" class="monaco"> -->
      <!-- <router-link to="/" class="text-white">hello</router-link> / -->
      <!-- <router-link to="/challenge" class="text-white">challenges</router-link> -->
      <!-- <router-link to="/score" class="text-white">score</router-link> -->
    <!-- </div> -->
    <router-view/>
    <!-- <Footer /> -->
    <!-- <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320"><path fill="#fff" fill-opacity="1" d="M0,192L57.6,96L115.2,192L172.8,256L230.4,288L288,64L345.6,224L403.2,192L460.8,288L518.4,32L576,288L633.6,288L691.2,128L748.8,224L806.4,160L864,224L921.6,288L979.2,256L1036.8,64L1094.4,96L1152,128L1209.6,256L1267.2,256L1324.8,64L1382.4,256L1440,32L1440,320L1382.4,320L1324.8,320L1267.2,320L1209.6,320L1152,320L1094.4,320L1036.8,320L979.2,320L921.6,320L864,320L806.4,320L748.8,320L691.2,320L633.6,320L576,320L518.4,320L460.8,320L403.2,320L345.6,320L288,320L230.4,320L172.8,320L115.2,320L57.6,320L0,320Z"></path></svg> -->
    <!-- <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320"><path fill="#ffffff" fill-opacity="1" d="M0,192L0,96L57.6,96L57.6,192L115.2,192L115.2,256L172.8,256L172.8,288L230.4,288L230.4,64L288,64L288,224L345.6,224L345.6,192L403.2,192L403.2,288L460.8,288L460.8,32L518.4,32L518.4,288L576,288L576,288L633.6,288L633.6,128L691.2,128L691.2,224L748.8,224L748.8,160L806.4,160L806.4,224L864,224L864,288L921.6,288L921.6,256L979.2,256L979.2,64L1036.8,64L1036.8,96L1094.4,96L1094.4,128L1152,128L1152,256L1209.6,256L1209.6,256L1267.2,256L1267.2,64L1324.8,64L1324.8,256L1382.4,256L1382.4,32L1440,32L1440,320L1382.4,320L1382.4,320L1324.8,320L1324.8,320L1267.2,320L1267.2,320L1209.6,320L1209.6,320L1152,320L1152,320L1094.4,320L1094.4,320L1036.8,320L1036.8,320L979.2,320L979.2,320L921.6,320L921.6,320L864,320L864,320L806.4,320L806.4,320L748.8,320L748.8,320L691.2,320L691.2,320L633.6,320L633.6,320L576,320L576,320L518.4,320L518.4,320L460.8,320L460.8,320L403.2,320L403.2,320L345.6,320L345.6,320L288,320L288,320L230.4,320L230.4,320L172.8,320L172.8,320L115.2,320L115.2,320L57.6,320L57.6,320L0,320L0,320Z"></path></svg> -->
  </div>
</template>

<script>
import Footer from "./components/Footer.vue";
import Tanggal from './components/Tanggal.vue'

export default {
  components: {Footer, Tanggal}
}
</script>

<style  >
#app {
  /* -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale; */
  text-align: center;
  height: 100vh;
  width: 100vw;
  margin: 0;
  /*background: url('~@/assets/img/wave4.svg') no-repeat center bottom;*/
  z-index: -1;
  overflow-y: auto;
}

#nav {
  padding: 30px;
  font-size: 2.9vh;
}

#nav a {
  font-weight: bold;
  /* color: #42b98351; */
  color: #4272b951;
  background-color: transparent;
}

#nav a.router-link-exact-active {
  color: #4272b9;
}

#nav a:hover {
  text-decoration-line: overline;
}
</style>
